<nb-layout>
  <nb-layout-header fixed *ngIf="isLoggedIn">
    <ngx-header></ngx-header>
  </nb-layout-header>

  <nb-sidebar *ngIf="isLoggedIn">
    <ngx-pages></ngx-pages>
    <nb-sidebar-footer [style.background-color]="environment.color">
      <strong>{{ compacted ? environment.fullName[0] : environment.fullName }}</strong>
    </nb-sidebar-footer>
  </nb-sidebar>

  <nb-layout-column>
    <router-outlet></router-outlet>
  </nb-layout-column>
</nb-layout>
